module.exports = __webpack_public_path__ + "static/media/Plain_Box.a679eef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Plain_Box.png
// module id = 1696
// module chunks = 0